<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo" style="z-index: 9999;">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          Yangi Mahalla Turar joy Majumuasi
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-0">
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <b-img
            :src="imgUrl"
            class="bgImg w-100 h-100"
            alt="Login V2"
            style="object-fit: cover;"
          />
          <div class="auth_overlay" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 pt-lg-2 pb-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto h-100 d-flex flex-column"
        >
          <div class="nav ml-auto mb-5">
            <locale @updateLocale="reLocalize" />
          </div>
          <div class="my-auto">
            <b-card-title title-tag="h2" class="font-weight-bold mb-1">
              {{ $t('login.authorization') }}
            </b-card-title>

            <!-- form -->
            <validation-observer ref="loginValidation">
              <b-form class="auth-login-form mt-2" @submit.prevent>
                <!-- email -->
                <b-form-group
                  :label="$t('login.login')"
                  label-for="login-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('login.login')"
                    rules="required"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="username"
                      :state="errors.length > 0 ? false : null"
                      name="login-email"
                      :placeholder="$t('login.login')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">{{
                      $t('login.password')
                    }}</label>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('login.password')"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  @click="validationForm"
                >
                  {{ $t('login.sign_in') }}
                </b-button>
              </b-form>
            </validation-observer>
          </div>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import uz from '@/libs/i18n/vee-validate/uz.json'
import ru from '@/libs/i18n/vee-validate/ru.json'

localize('uz', uz)

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    locale,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      sideImg: require('@/assets/images/pages/login/login_main.jpg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login/login_main.jpg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then((valid) => {
        if (!valid) return

        useJwt
          .login({ username: this.username, password: this.password })
          .then((resp) => {
            useJwt.setToken(resp.data.access)
            useJwt.setRefreshToken(resp.data.refresh)
            
            useJwt.setUserData(resp.data.user_data)
            this.$store.commit(
              'permission/setPermissionData',
              resp.data.permission_module
            )
            this.$store.dispatch('permission/getPermissionData')

            store
              .dispatch('users/EDIT_USER', {
                id: resp.data.user_data.id,
                language: this.$i18n.locale,
              })
              .then((user_resp) => {
                this.$_successToast(this.$t('generals.language_changed'))
                const user_data = user_resp.data
                useJwt.setUserData(user_data)
                if (
                  user_data.permission.includes('content_management') ||
                  user_data.is_superuser ||
                  user_data.permission.includes('supervisor') ||
                  user_data.permission.includes('super_manager')
                ) {
                  this.$router.push({ name: 'my-objects' })
                } else if (user_data.permission.includes('sales_management')) {
                  this.$router.push({ name: 'clients' })
                } else if (
                  user_data.permission.includes('finance_management')
                ) {
                  this.$router.push({ name: 'finance' })
                } else if (user_data.permission.includes('collector')) {
                  this.$router.push({ name: 'reports-by-objects' })
                } else if (user_data.permission.includes('manager')) {
                  this.$router.push({ name: 'my-objects' })
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `${this.$t('login.login_successfully')}, ${
                      user_data.username
                    }`,
                    icon: 'EditIcon',
                    variant: 'success',
                  },
                })
              })
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('login.incorrect_login'),
                icon: 'AlertOctagonIcon',
                variant: 'danger',
              },
            })
          })
      })
    },
    reLocalize(loc) {
      if (loc === 'uz') {
        localize(loc, uz)
      } else if (loc === 'ru') {
        localize(loc, ru)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.bgImg {
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.1);
}

.auth_overlay {
  background-color: #000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  opacity: 0.3;
  z-index: 100;
}
</style>
